export default "__VITE_ASSET__DVIO3Al5__"